export default __webpack_public_path__ + "static/media/ico_admin.fd38698d.png";